import { render, staticRenderFns } from "./StatusChanges.vue?vue&type=template&id=2a18404e&"
import script from "./StatusChanges.vue?vue&type=script&lang=js&"
export * from "./StatusChanges.vue?vue&type=script&lang=js&"
import style0 from "./StatusChanges.vue?vue&type=style&index=0&id=2a18404e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports